const campaignDetailLineItemMapping = {
  roundv: '@/views/campaign/details/detailRoundv.vue',
  drv: '@/views/campaign/details/detailDrv.vue',
  holev: '@/views/campaign/details/detailHolev.vue',
  virt_holev: '@/views/campaign/details/detailVirtualHolev.vue',
  score_banner: '@/views/campaign/details/detailBanner.vue',
  drv_end: '@/views/campaign/details/detailDrvEnd.vue',
  drv_left: '@/views/campaign/details/detailDrvLeft.vue',
  drv_right: '@/views/campaign/details/detailDrvRight.vue',
  drv_range: '@/views/campaign/details/detailDrvRange.vue',
  ingame_aboard: '@/views/campaign/details/detailIngameAboard.vue',
  ingame_tmarker: '@/views/campaign/details/detailIngameTmarker.vue',
  ingame_flag: '@/views/campaign/details/detailIngameFlag.vue',
  ingame_flat: '@/views/campaign/details/detailIngameFlat.vue',
  ingame_hole: '@/views/campaign/details/detailIngameHole.vue',
  ingame_myswing_bg: '@/views/campaign/details/detailIngameMyswingbg.vue',
  eventv: '@/views/campaign/details/detailEventv.vue',
  app: '@/views/campaign/details/detailApp.vue',
  dr_tboxbottomdecal: '@/views/campaign/details/detailDrTboxbot.vue',
  event: '@/views/campaign/details/internal/detailEvent.vue',
  BG_lobby: '@/views/campaign/details/internal/detailBGLobby.vue',
  BG_login: '@/views/campaign/details/internal/detailBGLogin.vue',
  dri: '@/views/campaign/details/internal/detailDri.vue',
  dr_heart: '@/views/campaign/details/internal/detailHeart.vue',
  dr_puttabanner: '@/views/campaign/details/internal/detailDrPuttabanner.vue',
  dr_flagbanner: '@/views/campaign/details/internal/detailDrFlagbanner.vue',
  ballskin: '@/views/campaign/details/internal/detailBallskin.vue',
  dr_distindecator:
    '@/views/campaign/details/internal/detailDrDistindecator.vue',
  stroke: '@/views/campaign/details/internal/detailStroke',
  competition: '@/views/campaign/details/internal/detailCompetition.vue',
  playersetting: '@/views/campaign/details/internal/detailPlayersetting.vue',
  lb_right: '@/views/campaign/details/internal/detailLbRight.vue',
  lb_screenrightdown: '@/views/campaign/details/internal/detailLbRightDown.vue',
  score: '@/views/campaign/details/internal/detailScore.vue',
  dr_leftbanner: '@/views/campaign/details/internal/detailDrLeftbanner.vue',
  dr_centerbanner: '@/views/campaign/details/internal/detailDrCenterbanner.vue',
  dr_all: '@/views/campaign/details/internal/detailDrall.vue',
  dr_competition: '@/views/campaign/details/internal/detailDrCompetition.vue',
};

export { campaignDetailLineItemMapping };
